<template>
  <div class="w-full mb-16">
    <div
      class="flex flex-col lg:flex-row shadow-xl rounded-lg relative mb-10"
      v-for="stop in tour.info.stops" :key="stop.id">
      <div class="w-full lg:w-2/5">
        <img :src="stop.image.url | getImagePath"
        :alt="stop.image.name"
        loading="lazy"
        class="object-cover h-full w-full rounded-t-lg lg:rounded-tr-none lg:rounded-l-lg" />
      </div>
      <div class="w-full lg:w-3/5 px-6 py-4
        flex flex-col justify-center text-left">
          <ebr-h2 :content="stop.title" />
          <ebr-p :content="stop.description" />
      </div>
    </div>
  </div>
</template>

<script>
import H2Vue from '../../atoms/typography/H2.vue';
import ParagraphVue from '../../atoms/typography/Paragraph.vue';

export default {
  props: {
    tour: {
      type: Object,
      required: true,
    },
  },
  components: {
    'ebr-h2': H2Vue,
    'ebr-p': ParagraphVue,
  },
};
</script>

<style>

</style>
